import { createSlice } from "@reduxjs/toolkit";
import { clone, get } from "lodash";

import { reset } from "../detail/shreddingDetailSlice";

export const DEFAULT_CRITICALITY_FILTERS = {
  HIGH: false,
  MEDIUM: false,
  LOW: false,
  IGNORE: false,
  UNMARKED: false,
  NOTES: false,
};

export const INITIAL_STATE = {
  criticalityFilters: clone(DEFAULT_CRITICALITY_FILTERS),
  selectedTermIds: [],
};

const shreddingFiltersSlice = createSlice({
  name: "filters",
  initialState: INITIAL_STATE,
  reducers: {
    resetAll: () => INITIAL_STATE,
    resetCriticalityFilters: (state) => {
      state.criticalityFilters = clone(DEFAULT_CRITICALITY_FILTERS);
    },
    setSelectedTermIds: (state, { payload = [] }) => {
      state.criticalityFilters = clone(DEFAULT_CRITICALITY_FILTERS);
      state.selectedTermIds = payload;
    },
    toggleCriticalityFiltersByKey: (state, { payload: key }) => {
      const { criticalityFilters } = state;
      const defaultFilters = clone(DEFAULT_CRITICALITY_FILTERS);
      const currentValue = get(criticalityFilters, key, false);

      state.selectedTermIds = [];

      // NOTES is considered a different Group, so treat as an OR.
      if (key === "NOTES") {
        state.criticalityFilters = { ...defaultFilters, [key]: !currentValue };
        return;
      }
      state.criticalityFilters = {
        ...criticalityFilters,
        NOTES: false,
        [key]: !currentValue,
      };
      return state;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(reset, () => INITIAL_STATE);
  },
});

export const {
  resetAll,
  resetCriticalityFilters,
  setSelectedTermIds,
  toggleCriticalityFiltersByKey,
} = shreddingFiltersSlice.actions;

export default shreddingFiltersSlice;
